//React
import React from "react";

import App from "../../../swimlane/App.tsx";
import "../../../swimlane/index.css"




const DefaultEditorSwimlane = (
  { swimlaneExport,
    id,
    allSwimLane,
    sId,
    t,
    approvallist,
    loadAllSwimlane,
    canEditMap,
    isProcessMapManager,
    setMap,
    layer,
    handleSelectionsChange,
    collaborators,
    setCollaborators,
    processesWithDiagrams,
    AnalyseId,
    onPermissionGranted,
    switchGuardsRef,
    isMapSwitching,
    mapSwitchTargetId,
    mapGenPending,
    onMapSwitchRenderComplete,
    onInitialRenderComplete,
    onSheetCacheUpdate,
  }
) => {

  return (

    <App
      swimlaneData={swimlaneExport}
      processId={id}
      allSwimLane={allSwimLane}
      loadAllSwimlane={loadAllSwimlane}
      sId={sId}
      canEditMap={canEditMap}
      isProcessMapManager={isProcessMapManager}
      approvallist={approvallist}
      setMap={setMap}
      layer={layer}
      handleSelectionsChange={handleSelectionsChange}
      collaborators={collaborators}
      setCollaborators={setCollaborators}
      processesWithDiagrams={processesWithDiagrams}
      AnalyseId={AnalyseId}
      onPermissionGranted={onPermissionGranted}
      switchGuardsRef={switchGuardsRef}
      isMapSwitching={isMapSwitching}
      mapSwitchTargetId={mapSwitchTargetId}
      mapGenPending={mapGenPending}
      onMapSwitchRenderComplete={onMapSwitchRenderComplete}
      onInitialRenderComplete={onInitialRenderComplete}
      onSheetCacheUpdate={onSheetCacheUpdate}
    />
  );
};

export default DefaultEditorSwimlane;
